module.exports = __webpack_public_path__ + "img/shipo-icon-airplane.e6eec066.svg";